export default "__VITE_ASSET__d6ef174a__"